import {
    DELETE_INSTITUTIONAL_CALENDAR_SUCCESS,
    ADD_INSTITUTIONAL_CALENDAR_SUCCESS,
    RESET_INSTITUTIONAL_CALENDAR,
    GET_INSTITUTIONAL_CALENDAR_LIST_SUCCESS,
    SELECT_ITEMS,
    SET_INITIAL_FORM_VALUES,
    RESET_INITIAL_FORM_VALUES,
    ENABLE_DISABLE_INSTITUTIONAL_CALENDAR,
    GET_INSTITUTIONAL_CALENDAR_LIST,
    GET_INSTITUTIONAL_CALENDAR_LIST_ERROR,
    ENABLE_DISABLE_INSTITUTIONAL_CALENDAR_SUCCESS,
    ENABLE_DISABLE_INSTITUTIONAL_CALENDAR_ERROR,
    ADD_INSTITUTIONAL_CALENDAR,
    ADD_INSTITUTIONAL_CALENDAR_ERROR,
} from "./institutionalCalendarActionTypes";

const initialState = {
    listResults: [],
    selectItems: [],
    isLoading: false,
    error: null,
    searchFormInitialValues: {
        searchForInstitutionalCalendar: '',
        startDate: null,
        endDate: null
    },
    addUpdateFormInitialValues: {
        name: '',
        code: '',
        calendarStartDate: null,
        calendarEndDate: null,
        active: true,
        description: '',
        dateType: 0,
    }
};

const institutionalCalendarReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_INSTITUTIONAL_CALENDAR_LIST:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case GET_INSTITUTIONAL_CALENDAR_LIST_SUCCESS:
            return {
                ...state,
                listResults: payload,
                isLoading: false
            };
        case GET_INSTITUTIONAL_CALENDAR_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
                error: payload
            };
        case DELETE_INSTITUTIONAL_CALENDAR_SUCCESS:
            return {
                ...state,
                listResults: state.listResults.filter(item => item.institutionalCalendarId !== payload)
            };
        case ADD_INSTITUTIONAL_CALENDAR:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case ADD_INSTITUTIONAL_CALENDAR_SUCCESS:
            return {
                ...state,
                listResults: payload.institutionalCalendarId 
                    ? state.listResults.map(item => item.institutionalCalendarId === payload.institutionalCalendarId ? payload : item)
                    : [...state.listResults, payload],
                isLoading: false
            };
        case ADD_INSTITUTIONAL_CALENDAR_ERROR:
            return {
                ...state,
                isLoading: false,
                error: payload
            };
        case RESET_INSTITUTIONAL_CALENDAR:
            return {
                ...state,
                searchFormInitialValues: {
                    searchForInstitutionalCalendar: '',
                    startDate: null,
                    endDate: null
                }
            };
        case SELECT_ITEMS:
            return {
                ...state,
                selectItems: payload.data.dateTypeList
            }
        case RESET_INITIAL_FORM_VALUES:
            return {
                ...state,
                addUpdateFormInitialValues: {
                    name: '',
                    code: '',
                    calendarStartDate: null,
                    calendarEndDate: null,
                    active: true,
                    description: '',
                    dateType: 0,
                    institutionalCalendarId: 0
                }
            };
        case SET_INITIAL_FORM_VALUES:
            if (payload !== null) {
                return {
                    ...state,
                    addUpdateFormInitialValues: {
                        "institutionalCalendarId": payload.institutionalCalendarId,
                        "name": payload.name,
                        "code": payload.code,
                        "calendarStartDate": payload.startDate,
                        "calendarEndDate": payload.endDate,
                        "active": payload.activeValue,
                        "description": payload.description,
                        "dateType": payload.dateTypeId
                    }
                };
            }
            break;
        case ENABLE_DISABLE_INSTITUTIONAL_CALENDAR:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case ENABLE_DISABLE_INSTITUTIONAL_CALENDAR_SUCCESS:
            const isActive = payload.activeValue ? 'Yes' : 'No';
            const updatedInstitutionalCalendar = state.listResults.map(ic => {
                if (ic.institutionalCalendarId === payload.institutionalCalendarId) {
                    return {
                        ...ic,
                        isActive: isActive,
                        activeValue: payload.active
                    }
                }

                return { ...ic };
            });
            return {
                ...state,
                listResults: updatedInstitutionalCalendar,
                isLoading: false
            };
        case ENABLE_DISABLE_INSTITUTIONAL_CALENDAR_ERROR:
            return {
                ...state,
                isLoading: false,
                error: payload
            };
        default:
            return state;
    }
};

export default institutionalCalendarReducer;
